<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col class="col-values">
        <v-btn
          outlined
          color="primary"
          class="ml-3"
          @click="
            $router.push(
              `/cidade/${municipioId}/agenteTerritorial/${tabType}/0`
            )
          "
        >
          Adicionar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template slot="no-data">
            <span> Nenhuma Governança </span>
          </template>
          <template v-slot:item.atuacao="{ item }">
            {{ item.atuacao ? "Sim" : "Não" }}
          </template>
          <template v-slot:item.relevancia="{ item }">
            {{ item.relevancia ? "Sim" : "Não" }}
          </template>
          <template v-slot:item.link="{ item }">
            <a
              :href="item.link"
              target="_blank"
              class="share-link"
              v-if="item.link"
            >
              <v-icon>mdi-share</v-icon></a
            >
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              outlined
              color="warning"
              class="mr-3"
              @click="
                $router.push(
                  `/cidade/${municipioId}/agenteTerritorial/${tabType}/${item.idGovernanca}`
                )
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <modalDelete :payload="item" @onDelete="load()">
              <template v-slot:title> Deletar Governança </template>
            </modalDelete>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { governancaApi } from "../Api/governanca";
import modalDelete from "./modalDelete";

export default {
  components: {
    modalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "nome", width: "20%" },
        { text: "Marco Legal", value: "marcoLegal" },
        { text: "Responsável", value: "responsavel" },
        { text: "Ativo", value: "atuacao" },
        { text: "Link", value: "link" },
        { text: "Relevante", value: "relevancia" },
        {
          text: "Ações",
          value: "actions",
        },
      ],
      values: [],
      tabType: this.$route.params.tab,
      municipioId: this.$route.params.id,

      search: "",
    };
  },

  methods: {
    ...mapActions(["setLoading", "setConfig"]),
    load() {
      this.setLoading(true);
      governancaApi.getByMunicipio(this.municipioId).then(({ data }) => {
        this.values = data;
        this.setLoading(false);
      });
    },
  },

  mounted() {
    this.load();
  },
};
</script>
<style scoped lang="scss">
.col-values {
  display: flex;
  justify-content: end;
}

.share-link {
  background: #5c8bb9 !important;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  width: 80%;
  .v-icon {
    color: #ffffff !important;
  }

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
      rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
      rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  }
}
</style>
